import type { Lang } from "./messages"

/**
 * Ciasteczko języka INTERFEJSU — celowo osobne od `_medusa_locale`, którego
 * starter używa do tłumaczenia treści po stronie backendu. Tamto przy zmianie
 * odpala aktualizację koszyka i unieważnianie cache'y; przełączenie samego
 * języka UI nie powinno ruszać koszyka.
 */
export const LANG_COOKIE = "ateisci_lang"

export const DEFAULT_LANG: Lang = "pl"

export const parseLang = (value?: string | null): Lang =>
  value === "en" ? "en" : DEFAULT_LANG
